export const VERIFY_AND_CHANGE_EMAIL = 'verifyAndChangeEmail';
export const RESET_PASSWORD = 'resetPassword';
export const RECOVER_EMAIL = 'recoverEmail';
